'use client'

import { useEffect } from 'react'

import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  HoVLandingPageModel,
  HoVLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { HoVBrandnewSection, HoVLogo } from './components'
import { HoVCreatorsSection } from './components/HoVCreatorsSection/HoVCreatorsSection'
import HoVClosetSection from './components/HoVClosetSection/HoVClosetSection'
import { HoVIntroduction } from './components/HoVIntroduction'
import { HoVBottomSection } from './components/HoVBottom'

type Props = { content: HoVLandingPageModel }

const HoVLandingPage = ({ content }: Props) => {
  const { track } = useTracking()

  useEffect(() => {
    const trackLandingPageView = async () =>
      track(
        landingPageEvent({
          event: HoVLandingPageEvent.LandingPageView,
          referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
          deviceId: await getFingerprint(),
        }),
      )

    trackLandingPageView()
  }, [track])

  return (
    <div className="hov__landing-page-container">
      <HoVLogo data={content.logo} />
      <HoVIntroduction data={content.introduction} />
      <HoVBrandnewSection data={content.brandnew} />
      <HoVCreatorsSection data={content.creators} />
      <HoVClosetSection data={content.closet} />
      <HoVBottomSection data={content.bottom} />
    </div>
  )
}

export default HoVLandingPage
